import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import logo from "../../images/full_logo.png";

const HeaderTop = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("lang", lng);
  };

  return (
    <div className="topbar">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-3 col-12 d-lg-block d-none">
            <Link className="navbar-brand" to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
          <div className="col-lg-9 col-12">
            <div className="contyact-info-wrap">
              <div className="contact-info">
                <div className="icon">
                  <i className="fi flaticon-phone-call"></i>
                </div>
                <div className="info-text">
                  <span>{t("headerTop.phone")}:</span>
                  <p>+992928808292</p>
                </div>
              </div>
              <div className="contact-info">
                <div className="icon">
                  <i className="fi flaticon-email"></i>
                </div>
                <div className="info-text">
                  <span>{t("headerTop.email")}</span>
                  <p>olamiroh@mail.ru</p>
                </div>
              </div>

              <div className="contact-info">
                <div className="info-text">
                  <span>
                    <button type="button" onClick={() => changeLanguage("ru")}>
                      {t("lang.ru")}
                    </button>
                  </span>
                </div>
                <div className="info-text">
                  <span>
                    <button type="button" onClick={() => changeLanguage("en")}>
                      {t("lang.en")}
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderTop;
